export default "__VITE_ASSET__1c1f528b__"